import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

const subsNewsletterMobile = {
  id: 'subscription-newsletter-mobile',
  componentType: 'subscriptionNewsletterMobile',
  condition: (options) => injectionHelpers.shouldInjectSubscriptionAndNewsletter({ options, viewport: 'mobile' }),
  component: ({
    promoBoxSettings, newsletterConfig, breakpoints, localConfig = {},
  }) => (localConfig['subscription-newsletter-mobile']
    ? localConfig['subscription-newsletter-mobile']({
      promoBoxSettings, newsletterConfig, breakpoints, viewport: 'mobile',
    })
    : config.getNewsletterSubscriptionConfig({
      promoBoxSettings, newsletterConfig, breakpoints, viewport: 'mobile',
    })),
  resetCurrentItemTypeCurrentCounter: false,
};

const subsNewsletterDesktop = {
  id: 'subscription-newsletter-desktop',
  componentType: 'subscriptionNewsletterDesktop',
  condition: (options) => injectionHelpers.shouldInjectSubscriptionAndNewsletter({ options, viewport: 'desktop' }),
  component: ({
    promoBoxSettings, newsletterConfig, breakpoints, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'subscription-newsletter-desktop',
    props: {
      promoBoxSettings, newsletterConfig, breakpoints, viewport: 'desktop',
    },
    defaultConfig: config.getNewsletterSubscriptionConfig({
      promoBoxSettings, newsletterConfig, breakpoints, viewport: 'desktop',
    }),
  }),
  resetCurrentItemTypeCurrentCounter: false,
};

export default [
  subsNewsletterMobile,
  subsNewsletterDesktop,
];
